import { COSMETICS, DEFAULT_EQUIPPED, type CosmeticDef, type CosmeticType, type EquippedCosmetics } from '@/models/cosmetics';

export class CosmeticsManager {
  private owned: Set<string> = new Set(['frame_default', 'badge_none', 'color_default']);
  private equipped: EquippedCosmetics = { ...DEFAULT_EQUIPPED };

  getOwned(): string[] { return [...this.owned]; }
  getEquipped(): EquippedCosmetics { return { ...this.equipped }; }
  owns(id: string): boolean { return this.owned.has(id); }

  grant(id: string): boolean {
    if (this.owned.has(id)) return false;
    const def = COSMETICS.find(c => c.id === id);
    if (!def) return false;
    this.owned.add(id);
    return true;
  }

  equip(id: string): boolean {
    if (!this.owned.has(id)) return false;
    const def = COSMETICS.find(c => c.id === id);
    if (!def) return false;
    this.equipped[def.type] = id;
    return true;
  }

  getEquippedValue(type: CosmeticType): string {
    const id = this.equipped[type];
    const def = COSMETICS.find(c => c.id === id);
    return def?.value ?? DEFAULT_EQUIPPED[type];
  }

  getOwnedByType(type: CosmeticType): CosmeticDef[] {
    return COSMETICS.filter(c => c.type === type && this.owned.has(c.id));
  }

  restoreState(owned: string[], equipped: EquippedCosmetics): void {
    this.owned = new Set(owned.length > 0 ? owned : ['frame_default', 'badge_none', 'color_default']);
    this.equipped = { ...DEFAULT_EQUIPPED, ...equipped };
  }
}
